/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authDeleteContent'

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('repo', {
      action: ['delete'],
      collection: [
        'app.bsky.feed.like',
        'app.bsky.feed.post',
        'app.bsky.feed.postgate',
        'app.bsky.feed.repost',
        'app.bsky.feed.threadgate',
      ],
    }),
  ],
  {
    title: 'Delete Bluesky Content',
    'title:lang': {},
    detail: 'Clean up public account history: posts, reposts, and likes.',
    'detail:lang': {},
  },
)

export { main }
